// src/components/ErrorAlert.js
import React from 'react';

const ErrorAlert = ({ message, onClose }) => {
    if (!message) {
        return null; //  如果 message 为空，不显示
    }

    return (
        <div className="error-alert"> {/*  可以添加 CSS 样式 */}
            <p>{message}</p>
            <button onClick={onClose}>关闭</button>
        </div>
    );
};

export default ErrorAlert;